import { render } from "./AppNewsletter.vue?vue&type=template&id=a37222a8"
import script from "./AppNewsletter.vue?vue&type=script&lang=js"
export * from "./AppNewsletter.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__